module.exports = __webpack_public_path__ + "img/lg.2da3a978.svg";